import { memo } from "react";
import { Link } from "react-router";

const NOTION_URL = "https://chillnn.notion.site/73a9db60da94497bb8a71eba9ff58b3d";

export const PriceSettingDescription = memo(() => {
	return (
		<div>
			<div className="space-y-1">
				<p>CHILLNNでは、部屋料金とプラン料金をそれぞれ設定することができます。</p>
				<p>このページでは、日帰りサウナプランなど、日帰りプランの料金設定ができます。</p>
				<p>
					<Link
						to={NOTION_URL}
						className="text-link-400 underline-offset-4 hover:underline"
						target="_blank"
						viewTransition
					>
						詳しくはこちら
					</Link>
				</p>
			</div>
		</div>
	);
});

PriceSettingDescription.displayName = "PriceSettingDescription";
